import { useEffect } from "react";
import PrimaryButton from "../components/PrimaryButton";
import { CardSubtitle, CardTitle, IconBadge } from "../components/AuthCard";
import { CheckIcon } from "../components/Icons";
import { REDIRECT_SECONDS } from "../constants";
import { useCountdown } from "../utils";
import styles from "../twoFactor.module.css";

// A12 — auto-redirects to home after 3s
const PasswordUpdated = ({ email, onGoHome }) => {
  const [remaining] = useCountdown(REDIRECT_SECONDS);

  useEffect(() => {
    if (remaining === 0) onGoHome();
  }, [remaining, onGoHome]);

  return (
    <div className="flex flex-col items-center text-center">
      <IconBadge tone="green" className="mb-4">
        <CheckIcon className="w-6 h-6" />
      </IconBadge>
      <CardTitle>Password updated</CardTitle>
      <CardSubtitle>
        Two-factor authentication is now active on your account. We&apos;ve sent a
        confirmation to <span className="font-geomanistBold text-blackShade">{email}</span>.
      </CardSubtitle>

      <div className="w-full h-1 mt-6 rounded-full bg-[#E3E4E8] overflow-hidden">
        <div
          className={`h-full bg-success ${styles.progress}`}
          style={{ animationDuration: `${REDIRECT_SECONDS}s` }}
        />
      </div>
      <p className="mt-2 mb-0 font-geomanistRegular text-xs text-geomanistgray">
        Taking you to your home page in {remaining}s…
      </p>

      <div className="w-full mt-5">
        <PrimaryButton title="Go to home" onClick={onGoHome} />
      </div>
    </div>
  );
};

export default PasswordUpdated;
